type Values<T> = T[keyof T];
type FlattenValues<T> = T extends object ? Values<{ [K in keyof T]: FlattenValues<T[K]> }> : T;
const i18nKeys = {
	main: {
		profile: {
			name: 'infa.profiling.fabric.main:profile.name',
			desc: 'infa.profiling.fabric.main:profile.desc',
		},
		name: 'infa.profiling.fabric.main:name',
		allStatistics: 'infa.profiling.fabric.main:allStatistics',
		columns: 'infa.profiling.fabric.main:columns',
		columnsAndRules: 'infa.profiling.fabric.main:columnsAndRules',
		filter: 'infa.profiling.fabric.main:filter',
		filterByKeywords: 'infa.profiling.fabric.main:filterByKeywords',
		hunderedPercentage: {
			constant: 'infa.profiling.fabric.main:hunderedPercentage.constant',
			distinct: 'infa.profiling.fabric.main:hunderedPercentage.distinct',
			null: 'infa.profiling.fabric.main:hunderedPercentage.null',
			blank: 'infa.profiling.fabric.main:hunderedPercentage.blank',
		},
		number: {
			nonDistinct: 'infa.profiling.fabric.main:number.nonDistinct',
			nulls: 'infa.profiling.fabric.main:number.nulls',
			distinct: 'infa.profiling.fabric.main:number.distinct',
		},
		percentage: {
			distinct: 'infa.profiling.fabric.main:percentage.distinct',
			nonDistinct: 'infa.profiling.fabric.main:percentage.nonDistinct',
			nulls: 'infa.profiling.fabric.main:percentage.nulls',
		},
		fiftyValues: 'infa.profiling.fabric.main:fiftyValues',
		Create: 'infa.profiling.fabric.main:Create',
		Cancel: 'infa.profiling.fabric.main:Cancel',
		seventyFiveValues: 'infa.profiling.fabric.main:seventyFiveValues',
		hunderedValues: 'infa.profiling.fabric.main:hunderedValues',
		blankPercentage: 'infa.profiling.fabric.main:blankPercentage',
		blankCount: 'infa.profiling.fabric.main:blankCount',
		minimumLength: 'infa.profiling.fabric.main:minimumLength',
		maximumLength: 'infa.profiling.fabric.main:maximumLength',
		minimumValue: 'infa.profiling.fabric.main:minimumValue',
		maximumValue: 'infa.profiling.fabric.main:maximumValue',
		descending: 'infa.profiling.fabric.main:descending',
		ascending: 'infa.profiling.fabric.main:ascending',
		rules: 'infa.profiling.fabric.main:rules',
		valueDistribution: 'infa.profiling.fabric.main:valueDistribution',
		view: 'infa.profiling.fabric.main:view',
		with: 'infa.profiling.fabric.main:with',
		readMore: 'infa.profiling.fabric.main:readMore',
		learnMore: 'infa.profiling.fabric.main:learnMore',
		allRowsCount: 'infa.profiling.fabric.main:allRowsCount',
		validationRuleDescription: 'infa.profiling.fabric.main:validationRuleDescription',
		autoGeneratedRuleOnDescription: 'infa.profiling.fabric.main:autoGeneratedRuleOnDescription',
		cancel: 'infa.profiling.fabric.main:cancel',
		dataPreview: 'infa.profiling.fabric.main:dataPreview',
		description: 'infa.profiling.fabric.main:description',
		insights: 'infa.profiling.fabric.main:insights',
		lastRunDate: 'infa.profiling.fabric.main:lastRunDate',
		noDataToDisplay: 'infa.profiling.fabric.main:noDataToDisplay',
		results: 'infa.profiling.fabric.main:results',
		rowRangeColumn: 'infa.profiling.fabric.main:rowRangeColumn',
		rulesRange: 'infa.profiling.fabric.main:rulesRange',
		type: 'infa.profiling.fabric.main:type',
		createdOn: 'infa.profiling.fabric.main:createdOn',
		updatePreview: 'infa.profiling.fabric.main:updatePreview',
		workspace: 'infa.profiling.fabric.main:workspace',
		backToSummary: 'infa.profiling.fabric.main:backToSummary',
		column: 'infa.profiling.fabric.main:column',
		countDistinctValues: 'infa.profiling.fabric.main:countDistinctValues',
		countNonUniqueValues: 'infa.profiling.fabric.main:countNonUniqueValues',
		countUniqueValues: 'infa.profiling.fabric.main:countUniqueValues',
		displayingValueFrequencyDistributionRange: 'infa.profiling.fabric.main:displayingValueFrequencyDistributionRange',
		frequency: 'infa.profiling.fabric.main:frequency',
		length: 'infa.profiling.fabric.main:length',
		allrules: 'infa.profiling.fabric.main:allrules',
		parser: 'infa.profiling.fabric.main:parser',
		custom: 'infa.profiling.fabric.main:custom',
		mapplet: 'infa.profiling.fabric.main:mapplet',
		cleanse: 'infa.profiling.fabric.main:cleanse',
		validation: 'infa.profiling.fabric.main:validation',
		verifier: 'infa.profiling.fabric.main:verifier',
		labeler: 'infa.profiling.fabric.main:labeler',
		addDataQualityRuleFromLibrary: 'infa.profiling.fabric.main:addDataQualityRuleFromLibrary',
		next: 'infa.profiling.fabric.main:next',
		previous: 'infa.profiling.fabric.main:previous',
		newRule: 'infa.profiling.fabric.main:newRule',
		show: 'infa.profiling.fabric.main:show',
		sortBy: 'infa.profiling.fabric.main:sortBy',
		value: 'infa.profiling.fabric.main:value',
		approve: 'infa.profiling.fabric.main:approve',
		clear: 'infa.profiling.fabric.main:clear',
		filterByKeyWords: 'infa.profiling.fabric.main:filterByKeyWords',
		hideRejectedInsights: 'infa.profiling.fabric.main:hideRejectedInsights',
		mulitpleAttemptFailure: 'infa.profiling.fabric.main:mulitpleAttemptFailure',
		insightsStatement: 'infa.profiling.fabric.main:insightsStatement',
		insightsType: 'infa.profiling.fabric.main:insightsType',
		reject: 'infa.profiling.fabric.main:reject',
		score: 'infa.profiling.fabric.main:score',
		status: 'infa.profiling.fabric.main:status',
		addDataToStartCreatingAQualityAsset: 'infa.profiling.fabric.main:addDataToStartCreatingAQualityAsset',
		autoCreateDataQuality: 'infa.profiling.fabric.main:autoCreateDataQuality',
		claireWillGenerateAndAttachTheFollowingRule: 'infa.profiling.fabric.main:claireWillGenerateAndAttachTheFollowingRule',
		cleanseRule: 'infa.profiling.fabric.main:cleanseRule',
		clickOnViewRecommendations: 'infa.profiling.fabric.main:clickOnViewRecommendations',
		createNew: 'infa.profiling.fabric.main:createNew',
		createNewValidationRule: 'infa.profiling.fabric.main:createNewValidationRule',
		createRule: 'infa.profiling.fabric.main:createRule',
		createYourDataQualityAsset: 'infa.profiling.fabric.main:createYourDataQualityAsset',
		dataClassificationCount: 'infa.profiling.fabric.main:dataClassificationCount',
		dataTypeAssignedToTheColumnInTheSourceObject: 'infa.profiling.fabric.main:dataTypeAssignedToTheColumnInTheSourceObject',
		dataTypesCount: 'infa.profiling.fabric.main:dataTypesCount',
		describeTheRule: 'infa.profiling.fabric.main:describeTheRule',
		Details: 'infa.profiling.fabric.main:Details',
		diameterShouldBeWithinRange: 'infa.profiling.fabric.main:diameterShouldBeWithinRange',
		documentedDataType: 'infa.profiling.fabric.main:documentedDataType',
		downPaymentShouldBeGreaterOrEqualTo1000: 'infa.profiling.fabric.main:downPaymentShouldBeGreaterOrEqualTo1000',
		forMoreExamplesReadMore: 'infa.profiling.fabric.main:forMoreExamplesReadMore',
		hereAreSomeExamples: 'infa.profiling.fabric.main:hereAreSomeExamples',
		input: 'infa.profiling.fabric.main:input',
		inputs: 'infa.profiling.fabric.main:inputs',
		syncExplorerFailedTitle: 'infa.profiling.fabric.main:syncExplorerFailedTitle',
		syncExplorerFailedDesc: 'infa.profiling.fabric.main:syncExplorerFailedDesc',
		syncExplorerTooltip: 'infa.profiling.fabric.main:syncExplorerTooltip',
		mostFrequentValuesCount: 'infa.profiling.fabric.main:mostFrequentValuesCount',
		noRecommendations: 'infa.profiling.fabric.main:noRecommendations',
		patternsCount: 'infa.profiling.fabric.main:patternsCount',
		phoneNumberCannotBeEmpty: 'infa.profiling.fabric.main:phoneNumberCannotBeEmpty',
		recommendations: 'infa.profiling.fabric.main:recommendations',
		rowCount: 'infa.profiling.fabric.main:rowCount',
		rowsCount: 'infa.profiling.fabric.main:rowsCount',
		ruleName: 'infa.profiling.fabric.main:ruleName',
		selectDataFromSomewhereElse: 'infa.profiling.fabric.main:selectDataFromSomewhereElse',
		selectSourceWithinOneLake: 'infa.profiling.fabric.main:selectSourceWithinOneLake',
		selectToViewDetailsAndCreateANewRule: 'infa.profiling.fabric.main:selectToViewDetailsAndCreateANewRule',
		theOutputOfValidationRuleLearnMore: 'infa.profiling.fabric.main:theOutputOfValidationRuleLearnMore',
		validationRule: 'infa.profiling.fabric.main:validationRule',
		viewDataQualityResults: 'infa.profiling.fabric.main:viewDataQualityResults',
		viewDatQualityNow: 'infa.profiling.fabric.main:viewDatQualityNow',
		viewRecommendations: 'infa.profiling.fabric.main:viewRecommendations',
		yourDataQualityAssetIsReady: 'infa.profiling.fabric.main:yourDataQualityAssetIsReady',
		outputs: 'infa.profiling.fabric.main:outputs',
		viewResults: 'infa.profiling.fabric.main:viewResults',
		profilingReady: 'infa.profiling.fabric.main:profilingReady',
		profilingProgress: 'infa.profiling.fabric.main:profilingProgress',
		rulesCount: 'infa.profiling.fabric.main:rulesCount',
		runProfiling: 'infa.profiling.fabric.main:runProfiling',
		runProfilingForTable: 'infa.profiling.fabric.main:runProfilingForTable',
		hintRunProfilingPage: 'infa.profiling.fabric.main:hintRunProfilingPage',
		creatingDQArtifact: 'infa.profiling.fabric.main:creatingDQArtifact',
		pickSrcArtifact: 'infa.profiling.fabric.main:pickSrcArtifact',
		somethingWentWrong: 'infa.profiling.fabric.main:somethingWentWrong',
		failedToConnectWithApi: 'infa.profiling.fabric.main:failedToConnectWithApi',
		failedToCreateRule: 'infa.profiling.fabric.main:failedToCreateRule',
		tryAgainLater: 'infa.profiling.fabric.main:tryAgainLater',
		viewDetails: 'infa.profiling.fabric.main:viewDetails',
		add: 'infa.profiling.fabric.main:add',
		startDataSourceSync: 'infa.profiling.fabric.main:startDataSourceSync',
		startDataSourceSyncDescription: 'infa.profiling.fabric.main:startDataSourceSyncDescription',
		continue: 'infa.profiling.fabric.main:continue',
		addRule: 'infa.profiling.fabric.main:addRule',
		frequencyTablePercentage: 'infa.profiling.fabric.main:frequencyTablePercentage',
		initInfaService: 'infa.profiling.fabric.main:initInfaService',
		loadingExplorer: 'infa.profiling.fabric.main:loadingExplorer',
		metadataExtrationTitle: 'infa.profiling.fabric.main:metadataExtrationTitle',
		metadataExtrationHint: 'infa.profiling.fabric.main:metadataExtrationHint',
		tableExtractionFailed: 'infa.profiling.fabric.main:tableExtractionFailed',
		sourceExtractionFailed: 'infa.profiling.fabric.main:sourceExtractionFailed',
		retry: 'infa.profiling.fabric.main:retry',
		explorer: 'infa.profiling.fabric.main:explorer',
		errorInitInfaService: 'infa.profiling.fabric.main:errorInitInfaService',
		fetchProfilingDetails: 'infa.profiling.fabric.main:fetchProfilingDetails',
		waitForJobToComplete: 'infa.profiling.fabric.main:waitForJobToComplete',
		errorFetchingProfilingStatus: 'infa.profiling.fabric.main:errorFetchingProfilingStatus',
		initIDQA: 'infa.profiling.fabric.main:initIDQA',
		checkAppRegistration: 'infa.profiling.fabric.main:checkAppRegistration',
		appRegistrationInProgress: 'infa.profiling.fabric.main:appRegistrationInProgress',
		retryAppRegistrationCheck: 'infa.profiling.fabric.main:retryAppRegistrationCheck',
		errorInitIDQA: 'infa.profiling.fabric.main:errorInitIDQA',
		tenantProvisioningNoAccessMsg: 'infa.profiling.fabric.main:tenantProvisioningNoAccessMsg',
		cannotCreateAssetMsg: 'infa.profiling.fabric.main:cannotCreateAssetMsg',
		cannotRunJobMsg: 'infa.profiling.fabric.main:cannotRunJobMsg',
		goToSetup: 'infa.profiling.fabric.main:goToSetup',
		cantCreateDQItem: 'infa.profiling.fabric.main:cantCreateDQItem',
		registrationPageMessage: 'infa.profiling.fabric.main:registrationPageMessage',
		syncJobFailed: 'infa.profiling.fabric.main:syncJobFailed',
		createArtifactSuccess: 'infa.profiling.fabric.main:createArtifactSuccess',
		genericCreateCSError: 'infa.profiling.fabric.main:genericCreateCSError',
		csCreateNotificationTitle: 'infa.profiling.fabric.main:csCreateNotificationTitle',
		csArtifactNotificationTitle: 'infa.profiling.fabric.main:csArtifactNotificationTitle',
		noData: 'infa.profiling.fabric.main:noData',
		selectTableToProceed: 'infa.profiling.fabric.main:selectTableToProceed',
		pageLoading: 'infa.profiling.fabric.main:pageLoading',
		pageFailure: 'infa.profiling.fabric.main:pageFailure',
		goToArtfact: 'infa.profiling.fabric.main:goToArtfact',
		artifactAlreadyExist: 'infa.profiling.fabric.main:artifactAlreadyExist',
		artifactCreationFailedError: 'infa.profiling.fabric.main:artifactCreationFailedError',
		urlToMccJobPage: 'infa.profiling.fabric.main:urlToMccJobPage',
	},
} as const;
export type TI18nKeys = FlattenValues<typeof i18nKeys>;
export default i18nKeys;
